export function isNullOrWhiteSpace(input: string | null | undefined): boolean {
    if (input === null || input === undefined)
        return true;

    return input.replace(/\s/g, "").length < 1;
}

export function isValidUrl(input: string | null | undefined): boolean {
    try {
        const url = new URL(input || "");
        return !!url;
    }
    catch {
        return false;
    }
}
